/**
 * KAN-759: просмотр заказа в модалке (CRM): позиции, количества, цены,
 * итог, статус, дата. Без правки; правка на странице заказа.
 */
import { OrderDialogShell } from './OrderDialogShell';
import { OrderItemsPanel } from './OrderItemsPanel';

interface OrderViewDialogProps {
  /** null: модалка закрыта. */
  orderId: string | null;
  onClose: () => void;
}

export function OrderViewDialog({ orderId, onClose }: OrderViewDialogProps) {
  return (
    <OrderDialogShell orderId={orderId} onClose={onClose} testId="order-view-dialog">
      {(order) => <OrderItemsPanel order={order} />}
    </OrderDialogShell>
  );
}
